//Custom Theme
const themeOverrides = {
  common: {
    fontFamily: ' "BarlowR", sans-serif ',
    fontFamilyMono: " sans-serif",
    fontSize: "12px",
    primaryColor: "#0b1d45FF",
    primaryColorHover: "#3152A7FF",
    primaryColorPressed: "#1B43A9FF",
    primaryColorSuppl: "#0b1d45FF",
    infoColor: "#0b1d45FF",
    infoColorHover: "#0b1d45FF",
    infoColorSuppl: "#0b1d45FF"
  },
  Button: {
    colorSecondary: "rgba(255, 255, 255, 1)",
    colorSecondaryHover: "rgba(96, 145, 194, 0.09)",
    colorSecondaryPressed: "rgba(15, 71, 128, 0.13)",
    border: "1px solid #0b1d45FF",
    borderHover: "1px solid #0b1d45FF",
    borderPressed: "1px solid #0b1d45FF",
    borderFocus: "1px solid #0b1d45FF",
    borderDisabled: "1px solid #274ba0",
    colorInfo: "#0b1d45FF",
    textColorTextInfo: " #0b1d45FF",
    colorHoverInfo: "#0b1d45FF",
    colorPressedInfo: "#0b1d45FF",
    colorFocusInfo: "#0b1d45FF",
    colorDisabledInfo: "#0b1d45A6",
    textColorTextHoverInfo: "#0b1d45FF",
    textColorTextPressedInfo: "#0b1d45FF",
    textColorTextFocusInfo: "#0b1d45FF",
    textColorTextDisabledInfo: "#0b1d45FF",
    borderInfo: "1px solid #869ED8FF",
    borderHoverInfo: "1px solid #869ED8FF",
    borderPressedInfo: "1px solid #869ED8FF",
    borderFocusInfo: "1px solid #869ED8FF",
    borderDisabledInfo: "1px solid #869ED8FF",
    rippleColorInfo: "#0b1d45FF",
    colorQuaternaryHover: "rgba(46, 51, 56, 0)",
    textColorGhostPressedInfo: "#0b1d45FF"
  },
  Typography: {
    headerMargin1: "0"
  },
  Breadcrumb: {
    itemTextColor: "#0b1d45FF",
    fontSize: "1.33rem",
    itemColorHover: "rgba(46, 51, 56, 0)",
    separatorColor: "#0b1d45FF"
  },
  Select: {
    
  },
  Scrollbar: {
    color: "#0b1d45FF",
    colorHover: "#0b1d45FF"
  },
  DatePicker: {
    itemTextColor: "#313131FF",
    panelTextColor: "#313131FF",
    arrowColor: "#0b1d45FF",
    calendarTitleTextColor: "#0b1d45FF",
    calendarTitleColorHover: "#0b1d45FF",
    iconColor: "#0b1d45FF"
  },
  Checkbox: {
    labelPadding: "0 1rem",
    fontSizeLarge: "1.1666rem",
    border: "1px solid #747474FF",
    textColor: "#313131FF"
  },
  Dialog: {
    iconColorInfo: "#234372FF",
    padding: "45px 35px 68px  35px",
    closeMargin: "18px 18px 0 0",
    closeMarginIconTop: "18px 18px 0 0",
    fontSize: "16px",
    border: "1px solid #E6E6E6FF",
    textColor: "#234372FF",
    closeIconColor: "#A3A3A3FF",
    closeIconColorHover: "#A3A3A3EB",
    closeIconColorPressed: "#A3A3A3FF",
    closeBorderRadius: "6px",
    closeColorHover: "rgba(0, 0, 0, 0)",
    closeColorPressed: "rgba(0, 0, 0, 0)",
    borderRadius: "6px"
  },
  Spin: {
    color: "#0b1d45FF"
  }
};
// use below mentioned buttons
// cancel or discard type btn ->  <n-button quaternary round type="info"
// submit, routing type btn ->  <n-button strong secondary round type="info"
// icon btn ->  <n-button quaternary circle type="info"
export default themeOverrides;
